<div class="col-12">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
  </form>
  <hr />
 
  <div class="row">
      <div class="col-9">
        <div class="col mt-3">
          <label>Subject</label>
          <editor [disabled]="!emailMessage.templateCode" name="email-subject" class="form-control form-control-sm" [init]="inlineToolbarConfig"
                  [(ngModel)]="emailMessage.subject"></editor>
        </div>
        <div class="col mt-3">
          <label>Message</label>
          <editor [disabled]="!emailMessage.templateCode" name="email-template" [init]="toolbarConfig" [(ngModel)]="emailMessage.content"></editor>
        </div>
        <div class="col text-center mt-3">
          <button class="btn btn-outline-primary me-2" (click)="back()">Cancel</button>
          <button class="btn btn-secondary me-2" (click)="onSave(f)">Save</button>
          <button class="btn btn-outline-primary me-2" (click)="refreshTemplate()">Refresh Template</button>
          <button *ngIf="!model.showSysTemplates" class="btn btn-secondary me-2"
                  (click)="initiateSaveToMany(f)">
            Save to multiple
            Locations
          </button>
          <button class="btn btn-outline-primary me-2" (click)="sendMe()" style="float:right">Preview</button>
          <input name="candidateID" placeholder="Candidate ID" type="text" class="form-control form-control-sm me-1" style="width:100px;float:right" [(ngModel)]='candidateID'>
        </div>
      </div>
      <div class="col-3">
<form class="needs-validation" #f="ngForm" novalidate>
  <div class="col mt-3">
    <label>From</label>
    <editor class="form-control form-control-sm overflowtext" name="txtFrom" #txtFrom="ngModel" [ngClass]="{ 'is-invalid': txtFrom.invalid && (txtFrom.dirty || f.submitted) }" pattern="^(?!.*[,:;]).*"
            [init]="inlineMailToolbarConfig" [(ngModel)]="emailMessage.fromAddresses"></editor>
      <div *ngIf="txtFrom.errors?.pattern" class="invalid-feedback">Only one email id is allowed in this field</div>
  
  </div>
  <div class="col mt-3">
    <label>To</label>
    <editor class="form-control form-control-sm overflowtext " [ngClass]="{ 'is-invalid': txtTo.invalid && (txtTo.dirty || f.submitted) }" name="txtTo" #txtTo="ngModel"
            [init]="inlineMailToolbarConfig" [(ngModel)]="emailMessage.toAddresses" pattern="^(?![,:;])+(?!.*[,:]).*"></editor>
    
      <div *ngIf="txtTo.errors?.pattern" class="invalid-feedback">Only semicolon seperation is allowed and usage of seperation at the beginning is restricted.</div>
   
  </div>
  <div class="col mt-3">
    <label>Cc</label>
    <editor class="form-control form-control-sm overflowtext " [ngClass]="{ 'is-invalid': txtCc.invalid && (txtCc.dirty || f.submitted) }" name="txtCc" #txtCc="ngModel"
            [init]="inlineMailToolbarConfig" [(ngModel)]="emailMessage.cc" pattern="^(?![,:;])+(?!.*[,:]).*"></editor>
   
      <div *ngIf="txtCc.errors?.pattern" class="invalid-feedback">Only semicolon seperation is allowed and usage of seperation at the beginning is restricted.</div>
  
  </div>
  <div class="col mt-3">
    <label>Bcc</label>
    <editor class="form-control form-control-sm overflowtext " [ngClass]="{ 'is-invalid': txtBcc.invalid && (txtBcc.dirty || f.submitted) }" name="txtBcc" #txtBcc="ngModel"
            [init]="inlineMailToolbarConfig" [(ngModel)]="emailMessage.bcc" pattern="^(?![,:;])+(?!.*[,:]).*"></editor>
    <div *ngIf="txtBcc.errors?.pattern" class="invalid-feedback">Only semicolon seperation is allowed and usage of seperation at the beginning is restricted.</div>

  </div>
</form>
    <div class="col mt-3">
      <form name="form" class="needs-validation col-12 p-0" #u="ngForm" novalidate>
        <label>Attach file</label>
        <div class="input-group mb-3">
          <input [disabled]="disableUpload" #fileControl name="fileName" type="file"
                 (change)="fileSelected($event.target.files)" #fileName [accept]="fileBrowserAllowedTypes"
                 style="display: none;">

          <input #fileField type="text" class="form-control form-control-sm readonly-date" readonly
                 [value]="selectedFileName" [ngClass]="{ 'is-invalid': fileName.dirty && !selectedDocument }"
                 required />
          <div class="input-group-append">
            <button type="button" [disabled]="disableUpload" (click)="browseFile()"
                    class="btn-outline-primary">
              Browse
            </button>
          </div>
          <div>
            <button type="button" [disabled]="!selectedDocument || disableUpload" (click)="uploadDoc(u)"
                    class="btn btn-secondary">
              <span *ngIf="!disableUpload">Attach</span>
              <span *ngIf="disableUpload" class="spinner m-3 reset-spinner-left"></span>
            </button>
          </div>
        </div>
        <div class="invalid-feedback">
          <span *ngIf="ifDocNotValid">
            File size greater than 10Mb is not allowed
          </span>
          <span>
            File is required
          </span>
        </div>
      </form>
    </div>
    <div class="col mt-3"
         *ngIf="emailMessage.attachments && emailMessage.attachments.length > 0 || uploadedFiles && uploadedFiles.length > 0 ">
      <label>Attachments</label>
      <div *ngFor="let doc of emailMessage.attachments; let i = index"
           class="attachment m-1 d-flex p-1 justify-content-between align-items-center ">
        <div class="d-flex">
          <div class="ml-2" (click)="downloadFile(doc)">
            <img src="design/images/paperclip.png" style="width: 20px;height:20px" alt="attachment">
          </div>
          <div class="mx-2 text-white">
            {{doc | replace }}
          </div>
        </div>
        <a class="me-2" (click)="removeAttachment(doc)">
          <img src="design/images/cancel.png" class="cursor-pointer" style="width: 10px;height:10px"
               alt="remove">
        </a>

      </div>

      <div *ngFor="let doc of uploadedFiles; let i = index"
           class="attachment m-1 d-flex p-1 justify-content-between align-items-center ">
        <div class="d-flex">
          <div class="ml-2" (click)="downloadAttachment(doc)">
            <img src="design/images/paperclip.png" class="cursor-pointer"
                 style="width: 20px;height:20px" alt="attachment">
          </div>
          <div class="mx-2 text-white">
            {{doc.fileName | replace }}
          </div>
        </div>
        <a class="me-2" (click)="deleteAttachment(doc)">
          <img src="design/images/cancel.png" class="cursor-pointer" style="width: 10px;height:10px"
               alt="remove">
        </a>

      </div>
    </div>




    </div>
  </div>
</div>
